import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Inbox, Upload, LogOut } from 'lucide-react';
import { supabase } from '@/supabaseClient';

export default function MobileLayout() {
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = async () => {
        await supabase.auth.signOut();
        navigate('/login');
    };

    const isActive = (path) => location.pathname === path;

    return (
        <div className="flex flex-col h-[100dvh] bg-background">
            {/* Content Area */}
            <main className="flex-1 overflow-y-auto pb-20">
                <Outlet />
            </main>

            {/* Bottom Navigation Bar */}
            <nav className="fixed bottom-0 left-0 right-0 h-16 bg-card border-t flex items-center justify-around z-50 pb-safe">
                <button
                    onClick={() => navigate('/mobile')}
                    className={`flex flex-col items-center justify-center w-full h-full space-y-1 ${isActive('/mobile') ? 'text-primary' : 'text-muted-foreground'
                        }`}
                >
                    <Inbox className="h-6 w-6" />
                    <span className="text-[10px] font-medium">Bandeja</span>
                </button>

                <button
                    onClick={() => navigate('/mobile/upload')} // Placeholder for now, or modal
                    className={`flex flex-col items-center justify-center w-full h-full space-y-1 ${isActive('/mobile/upload') ? 'text-primary' : 'text-muted-foreground'
                        }`}
                >
                    <div className="h-10 w-10 bg-primary text-primary-foreground rounded-full flex items-center justify-center shadow-lg -mt-6 border-4 border-background">
                        <Upload className="h-6 w-6" />
                    </div>
                    <span className="text-[10px] font-medium">Subir</span>
                </button>

                <button
                    onClick={handleLogout}
                    className="flex flex-col items-center justify-center w-full h-full space-y-1 text-muted-foreground hover:text-destructive"
                >
                    <LogOut className="h-6 w-6" />
                    <span className="text-[10px] font-medium">Salir</span>
                </button>
            </nav>
        </div>
    );
}
